import React from "react";

export const Header = () => {
  return <header>header</header>;
};
